import { ArtifactV3_Output, EditorMessage } from 'src/types';
import { editorApi } from '../services';

export const upsertEditorThreadMessage = ({
  user_id,
  thread_id,
  message,
  isStreaming,
}: {
  user_id: string;
  thread_id: string;
  message: EditorMessage;
  isStreaming: boolean;
}) => {
  return editorApi.util.updateQueryData(
    'getEditorThreadById',
    {
      user_id,
      thread_id,
    },
    (draft) => {
      if (!draft) {
        return;
      }

      const focusMessage = draft.messages?.find(
        (item: EditorMessage) => item.id === message.id,
      );

      if (!focusMessage) {
        draft.messages
          ? draft.messages.push(message)
          : (draft.messages = [message]);

        draft.internal_messages
          ? draft.internal_messages.push(message)
          : (draft.internal_messages = [message]);
        return;
      }

      const updatedMessage = {
        ...message,
        content: isStreaming
          ? `${focusMessage.content}${message.content}`
          : message.content,
      };

      Object.assign(focusMessage, updatedMessage);
    },
  );
};

export const upsertEditorArtifact = ({
  user_id,
  thread_id,
  artifactOutput,
}: {
  user_id: string;
  thread_id: string;
  artifactOutput: ArtifactV3_Output;
}) => {
  return editorApi.util.updateQueryData(
    'getEditorThreadById',
    {
      user_id,
      thread_id,
    },
    (draft) => {
      if (!draft) {
        return;
      }

      Object.assign(draft, { artifact: artifactOutput });
    },
  );
};
